import { render, staticRenderFns } from "./IncomesOutcomes.vue?vue&type=template&id=b127472c&"
import script from "./IncomesOutcomes.vue?vue&type=script&lang=js&"
export * from "./IncomesOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports